export default (a, b) => {
  if (_.isArray(a)) {
    return b;
  }
};



// WEBPACK FOOTER //
// ./src/widget/utils/replace-arrays.js